var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"500px","height":"500px"},attrs:{"id":"qr-code-full-region"}})
}
var staticRenderFns = []

export { render, staticRenderFns }